<button pButton type="button" icon="pi pi-plus" label="Create This Page" (click)="openCreatePageDialog()"></button>

<p-dialog [(visible)]="createPageDialogVisible" *ngIf="createPageInput.page">
    <ng-template pTemplate="header">
        Create Page
    </ng-template>
    <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="pi pi-align-left"></i></span>
        <input type="text" [(ngModel)]="createPageInput.page.title" pInputText placeholder="Page Title"
        [class.invalid-input]="!createPageValidation.title.valid && createPageValidation.title.touched"
        (keyup)="validate('title')" 
        (focusout)="focusOut('title')">
    </div>
    <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="pi pi-align-left"></i></span>
        <input type="text" [(ngModel)]="createPageInput.page.path" [disabled]="pathLocked" pInputText placeholder="Path"
        [class.invalid-input]="!createPageValidation.path.valid && createPageValidation.path.touched"
        (keyup)="validate('path')" 
        (focusout)="focusOut('path')">
    </div>
    <small>Should be in the format '/testing/test'</small>
    <p-footer>
        <button pButton 
        class="p-button-success" [disabled]="!createPageValidation.title.valid || !createPageValidation.path.valid" 
        type="button" icon="pi pi-plus" label="Create Page" (click)="createPage()"></button>
    </p-footer>
</p-dialog>